import SidebarLayout from '../../components/SidebarLayout';
import OutcomesUpdateForm from '../../components/sections/MTSS/OutcomesUpdateForm';
import { useParams } from 'react-router-dom';
import AccessWrapper from '../../components/AccessWrapper';
import AuthContext from '../../context/AuthContext';
import { useContext, useEffect } from 'react';

export default function OutcomesUpdate() {
  const params = useParams();
  const id = params?.id;
  const { postPageView, user, baseUrl } = useContext(AuthContext);

  useEffect(() => {
    postPageView(baseUrl, user.name, user.role, 'form/update-outcome');
  }, []);
  return (
    <AccessWrapper allowedGroups={['mtss_admin']}>
      <div>
        <SidebarLayout
          propComponents={<OutcomesUpdateForm params={id} />}
          heading={'Update Outcome'}
        />
      </div>
    </AccessWrapper>
  );
}
